<template>
    <div>
        <Toast 
            v-if="showToast"
            :title="toastTitle"
            :message="toastMessage"
            :type="toastType"
            @toast-click="hideToast"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { useToast } from '@/composables';
import Toast from './ui/Toast.vue';

export default {
    name: 'GlobalErrorHandler',
    components: {
        Toast
    },
    setup() {
        const { showToast, toastTitle, toastMessage, toastType, displayToast, hideToast } = useToast();

        return {
            showToast,
            toastTitle,
            toastMessage,
            toastType,
            displayToast,
            hideToast
        };
    },
    computed: {
        ...mapGetters('common', ['getLatestError'])
    },
    watch: {
        getLatestError(error) {
            if (error) {
                this.displayToast(
                    'Error',
                    `${error.context}: ${error.message}`,
                    'error'
                );
            }
        }
    }
};
</script>